import script from "./LiveScore.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveScore.vue?vue&type=script&setup=true&lang=js"

import "./LiveScore.vue?vue&type=style&index=0&id=1859db09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1859db09"]])

export default __exports__